/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		minHeight: 28,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 9,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: '#ffffff',
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '8%',
		textAlign: 'center',
	},

	name: {
		width: '15%',
		textAlign: 'left',
	},

	user: {
		width: '15%',
		textAlign: 'left',
	},

	dateTime: {
		width: '15%',
		textAlign: 'center',
	},

	pipelineChainage: {
		width: '17%',
		textAlign: 'center'
	},

	remarks: {
		width: '15%',
		textAlign: 'left',
	},

	status: {
		width: '15%',
		textAlign: 'center',
		borderRightWidth: 0,
	},
});

const paginate = (array, perPage) => {
	const pages = [];

	for (let i = 0; i < array.length; i += perPage) {
		pages.push(array.slice(i, i + perPage));
	}

	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice || [], itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>
					
					{/* page break after first page */}
					{pageIndex > 0 && <View break />}

					<View wrap>
						{/* ✅ UPDATED HEADER */}
						<View style={styles.container}>
							<Text style={[styles.headerCell, styles.id]}>
								ID
							</Text>

							<Text style={[styles.headerCell, styles.name]}>
								Name
							</Text>

							<Text style={[styles.headerCell, styles.user]}>
								User
							</Text>

							<Text style={[styles.headerCell, styles.dateTime]}>
								Date Time
							</Text>

							<Text style={[styles.headerCell, styles.pipelineChainage]}>
								Chainage
							</Text>

							<Text style={[styles.headerCell, styles.remarks]}>
								Remarks
							</Text>

							<Text style={[styles.headerCell, styles.status]}>
								Status
							</Text>
						</View>

						{/* Rows */}
						<InvoiceTableRow data={pageData} />
					</View>
				</React.Fragment>
			))}
		</>
	);
};

export default InvoiceItemsTable;